import './OkulyonetimAddedToClass.scss'

import { DeleteFilled, EditFilled } from '@ant-design/icons'
import { Button, Collapse, Modal, notification, Popover, Table, TableProps, Tooltip } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { saveAs } from 'file-saver'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as XLSX from 'xlsx'

import {AppRoutes} from "../../../App";
import AppContext from '../../../context/AppContext'
import {
  useDersListesiniOnayaGonderMutation,
  useEklenenSinifDersleriLazyQuery,
  useSinifDersUrunuAdetGuncellemeMutation,
  useSinifDersUrunuNotGuncellemeMutation,
  useSinifDersUrunuSilmeMutation,
} from '../../../gql/GeneratedGraphqlTypes'
import {getFormattedPrice} from "../../../helpers/Formatting";
import Spinner from '../../spinner/Spinner'
import { ReactComponent as ExcelIcon } from './icons/export.svg'
import { ReactComponent as MinusIcon } from './icons/minus.svg'
import { ReactComponent as PlusIcon } from './icons/plus.svg'
import { ReactComponent as SendIcon } from './icons/send.svg'
import { ReactComponent as UpdateIcon } from './icons/update.svg'

const { Panel } = Collapse
interface DataType {
  key: string
  productImage: string
  lessonColor: string
  class: string
  barcode: string
  lesson: string
  classId: number
  productId: number
  productName: string
  price: string
  quantity: number
  note: string
  sinif_akif_mi: boolean
  ders_aktif: boolean
}

const OkulyonetimAddedToClass = () => {
  const { sinif } = useContext(AppContext)
  const navigate = useNavigate()

  const [currentNote, setCurrentNote] = useState<string>('')
  const [editingKey, setEditingKey] = useState<string | null>(null)
  const [popoverVisible, setPopoverVisible] = useState<boolean>(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState<{ productId: number; classId: number } | null>(null)
  const [selectedSinif, setSelectedSinif] = useState<number | null>(null)
  const [isApprovalModalVisible, setIsApprovalModalVisible] = useState(false)
  const [data, setData] = useState<any>(null)
  const [user, setUser] = useState<any>()
  const [loading, setLoading] = useState(true)
  const [quantities, setQuantities] = useState<{ [key: string]: number }>({})

  const handleIncrement = (record: DataType) => {
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [record.key]: (prevQuantities[record.key] || record.quantity) + 1,
    }))
  }

  const handleDecrement = (record: DataType) => {
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [record.key]:
        (prevQuantities[record.key] || record.quantity) > 1 ? (prevQuantities[record.key] || record.quantity) - 1 : 1,
    }))
  }

  const excelButtonText =
    'Bu buton listenizi excel olarak almanızı sağlar. Listeyi onayladığınızda ayrıca mail ile de tarafınıza gönderilecektir. Gelen çizelgedeki fiyatlar güncel olmayabilir.'
  const confirmButtonText =
    'Bu butona ilgili sınıf için tüm seçimlerinizi ekledikten sonra basınız. Onayladığınız listelerde değişiklik yapamayacaksınız. Onay sonrası değişiklik ihtiyacı halinde yöneticinizden listenin onayını kaldırmasını talep edebilirsiniz.'
  const updateAmountButtonText =
    'Ürünün listelerdeki adedini değiştirmek için önce istediğiniz adedi seçip sonra bu butona basınız. Butona basmadan değiştirdiğiniz adet kaydedilmeyecektir.'

  const tooltipStyle: React.CSSProperties = {
    maxWidth: '400px',
    whiteSpace: 'normal',
  } // antDesign class'lari karisik oldugu icin style yazdim

  const [sinifDersUrunuEkleMutation] = useSinifDersUrunuNotGuncellemeMutation()
  const [sinifDersUrunuAdetDuzenleMutation] = useSinifDersUrunuAdetGuncellemeMutation()
  const [sinifDersUrunuSilmeMutation] = useSinifDersUrunuSilmeMutation()
  const [dersListesiniOnayaGonderMutation] = useDersListesiniOnayaGonderMutation()
  const [fetchEklenenSinifDersleri] = useEklenenSinifDersleriLazyQuery()
  const showApprovalModal = (sinifId: number) => {
    setSelectedSinif(sinifId)
    setIsApprovalModalVisible(true)
  }

  const handleSendApproval = async () => {
    if (selectedSinif) {
      try {
        const response = await dersListesiniOnayaGonderMutation({
          variables: {
            input: {
              sinifdersi_id: selectedSinif,
              sube_id: sinif || 0
            },
          },
        })
        if (response.data?.dersListesiniOnayaGonder.success) {
          notification.success({
            message: '',
            description: `${response.data?.dersListesiniOnayaGonder?.message}`,
            duration: 6,
          })
          await fetchSinifDersleriData()
        } else {
          notification.error({
            message: '',
            description: `${response.data?.dersListesiniOnayaGonder?.message || 'Bir hata oluştu'}`,
            duration: 6,
          })
        }
      } catch (error) {
        notification.error({
          message: '',
          description: 'Listeyi gönderirken bir hata oluştu.',
          duration: 6,
        })
      } finally {
        setIsApprovalModalVisible(false)
      }
    }
  }
  const handleDeleteConfirm = async () => {
    if (selectedRecord) {
      const { productId, classId } = selectedRecord
      try {
        const response = await sinifDersUrunuSilmeMutation({
          variables: {
            input: {
              urun_id: productId,
              sinifdersi_id: classId,
            },
          },
        })
        if (response.data?.sinifDersUrunuSilme.success) {
          notification.success({
            message: '',
            description: `${response.data?.sinifDersUrunuSilme?.message}`,
            duration: 6,
          })
          await fetchSinifDersleriData()
        } else {
          notification.error({
            message: '',
            description: `${response.data?.sinifDersUrunuSilme?.message || 'Bir hata oluştu'}`,
            duration: 6,
          })
        }
      } catch (error) {
        notification.error({
          message: '',
          description: `'Silme işlemi sırasında bir hata oluştu.'.`,
          duration: 6,
        })
      } finally {
        setIsModalVisible(false)
        setSelectedRecord(null)
      }
    }
  }

  const showDeleteModal = (productId: number, classId: number) => {
    setSelectedRecord({ productId, classId })
    setIsModalVisible(true)
  }
  const handleSaveNote = async (lessonID: number, classId: number) => {
    setEditingKey(null) // Düzenleme modundan çık
    setCurrentNote('') // Notu sıfırla
    try {
      const response = await sinifDersUrunuEkleMutation({
        variables: {
          input: {
            urun_id: lessonID,
            sinifdersi_id: classId,
            ders_notu: currentNote,
          },
        },
      })
      if (response.data?.sinifDersUrunuNotGuncelleme.success) {
        notification.success({
          message: '',
          description: `${response.data?.sinifDersUrunuNotGuncelleme?.message}`,
          duration: 6,
        })
        await fetchSinifDersleriData()
      } else {
        notification.error({
          message: '',
          description: `${response.data?.sinifDersUrunuNotGuncelleme?.message || 'Bir hata oluştu'}`,
          duration: 6,
        })
      }
    } catch (error) {
      // Hata mesajı göster
      notification.error({
        message: '',
        description: `'işlem sırasında bir hata oluştu.'.`,
        duration: 6,
      })
    }
  }

  const handleUptadeLesson = async (productId: number, classId: number, quantities: number) => {
    try {
      const response = await sinifDersUrunuAdetDuzenleMutation({
        variables: {
          input: {
            urun_id: productId,
            sinifdersi_id: classId,
            adet: quantities,
          },
        },
      })
      if (response.data?.sinifDersUrunuAdetGuncelleme.success) {
        notification.success({
          message: '',
          description: `${response.data?.sinifDersUrunuAdetGuncelleme?.message}`,
          duration: 6,
        })
        await fetchSinifDersleriData()
      } else {
        notification.error({
          message: '',
          description: `${response.data?.sinifDersUrunuAdetGuncelleme?.message || 'Bir hata oluştu'}`,
          duration: 6,
        })
      }
    } catch (error) {
      // Hata mesajı göster
      notification.error({
        message: '',
        description: `'Ekleme işlemi sırasında bir hata oluştu.'.`,
        duration: 6,
      })
    }
  }
  const handleCancelNote = () => {
    setEditingKey(null) // Düzenleme modundan çık
    setCurrentNote('') // Notu sıfırla
    setPopoverVisible(false)
  }

  const fetchSinifDersleriData = useCallback(async () => {
    setLoading(true)
    try {
      if (sinif && sinif > 0) {
        const response = await fetchEklenenSinifDersleri({
          variables: { sube_id: sinif || 0 },
          fetchPolicy: 'network-only',
        })
        if (response.data) {
          setData(response.data)
          setUser(response.data.eklenenSinifDersleri?.ogretmen ? response.data.eklenenSinifDersleri.ogretmen : '')
        } else {
          throw new Error('Veri alınamadı')
        }
      }
    } catch (error) {
      console.error(error)
      navigate('/')
    } finally {
      setLoading(false)
    }
  }, [fetchEklenenSinifDersleri, navigate, sinif])

  useEffect(() => {
    fetchSinifDersleriData() // useEffect içinde callback'i çağır
  }, [fetchSinifDersleriData]) // Callback fonksiyonunu bağımlılık olarak ekle

  if (loading) {
    return <Spinner showSpinner={loading} color="red" />
  }

  if (!data) {
    return <div></div>
  }

  const content = (key: string, existingNote: string, productId: number, classId: number) => (
    <div className="okulyonetim-added-to-class-table-note">
      <TextArea
        placeholder="Ürün Notu Ekle"
        rows={3}
        autoSize={{ minRows: 3, maxRows: 5 }}
        value={editingKey === key ? currentNote : existingNote}
        onChange={(e) => setCurrentNote(e.target.value)}
      />
      <div style={{ marginTop: 8, textAlign: 'right' }}>
        <Button onClick={handleCancelNote} style={{ marginRight: 8 }}>
          İptal
        </Button>
        <Button type="primary" onClick={() => handleSaveNote(productId, classId)}>
          Kaydet
        </Button>
      </div>
    </div>
  )
  // ToDo: renk gelmiyor
  const columns: TableProps<DataType>['columns'] = [
    {
      dataIndex: 'lessonColor',
      key: 'lessonColor',
      width: '5%',
      align: 'left',
      render: (_, record) => {
        return (
          <div
            style={{
              backgroundColor: record.lessonColor, // lessonColor burada atanıyor
              height: 130,
              borderRadius: 20,
              width: '100%',
            }}
          />
        )
      },
    },
    {
      title: 'Ürün Fotoğrafı',
      dataIndex: 'productImage',
      key: 'productImage',
      width: '40%',
      align: 'left',
      render: (_, record) => (
        <div className="okulyonetim-added-to-class-table">
          <div className="okulyonetim-added-to-class-table-product">
            <img  onClick={() =>
                window.open(
                    `/v1/${AppRoutes.okulyonetim.base}/${AppRoutes.okulyonetim.productDetail}/${record.productId}`,
                    '_blank',
                    'noopener,noreferrer',
                )
            } src={record.productImage} alt="" />
            <span className="table-product-title">{record.productName} </span>
          </div>
          {record.note && <div className="record-note">{record.note}</div>}
        </div>
      ),
    },
    {
      title: 'Ders',
      dataIndex: 'lesson',
      key: 'lesson',
      align: 'left',
      width: '30%',
      render: (_, record) => (
        <div className="table-content-lesson">
          <div
            className="lesson-name-color-div"
            style={{
              backgroundColor: record.lessonColor,
            }}
          ></div>
          <Tooltip title={record.lesson} placement="top" mouseEnterDelay={0.2} overlayStyle={tooltipStyle}>
            <div>{record.lesson.slice(0, 20)}</div>
          </Tooltip>
        </div>
      ),
    },
    {
      title: 'Birim Fiyat',
      dataIndex: 'price',
      key: 'price',
      align: 'left',
      width: '15%',
      render: (_, record) => (
          getFormattedPrice(record.price)
      )
    },
    {
      title: 'Adet',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center',
      render: (_, record) => (
        <div className={`okulyonetim-added-to-class-table-quantity ${record.ders_aktif ? 'disabled-div' : ''}`}>
          <Button
            icon={<MinusIcon />}
            onClick={() => handleDecrement(record)}
            disabled={record.ders_aktif || (quantities[record.key] || record.quantity) <= 1}
          />
          <span className="quantity-span">{quantities[record.key] || record.quantity}</span>
          <Button icon={<PlusIcon />} onClick={() => handleIncrement(record)} disabled={record.ders_aktif} />
        </div>
      ),
    },
    {
      title: 'İşlem',
      key: 'action',
      align: 'center',
      render: (_, record) => (
        <div className="okulyonetim-added-to-class-table-buttons">
          {!record.ders_aktif && (
            <>
              <div>
                {!record.ders_aktif && (
                  <Popover
                    content={content(record.key, record.note, record.productId, record.classId)}
                    title="Ürün Notu"
                    trigger="click"
                    open={editingKey === record.key && popoverVisible}
                    onOpenChange={(visible) => {
                      setPopoverVisible(visible)
                      if (visible) {
                        setEditingKey(record.key)
                      } else {
                        setEditingKey(null)
                        setCurrentNote('')
                      }
                    }}
                  >
                    <Button className="okulyonetim-added-to-class-table-buttons-note">
                      <EditFilled /> Not Ekle
                    </Button>
                  </Popover>
                )}
              </div>
              <Tooltip placement="top" title={updateAmountButtonText} mouseEnterDelay={0.2} overlayStyle={tooltipStyle}>
                <Button
                  onClick={() =>
                    handleUptadeLesson(record.productId, record.classId, quantities[record.key] || record.quantity)
                  }
                  className="okulyonetim-added-to-class-table-buttons-edit"
                >
                  <UpdateIcon /> Adedi Güncelle
                </Button>
              </Tooltip>
              <Button
                onClick={() => showDeleteModal(record.productId, record.classId)}
                className="okulyonetim-added-to-class-table-buttons-delete"
              >
                <DeleteFilled /> Kaldır
              </Button>
            </>
          )}
        </div>
      ),
    },
  ]
  const exportAllToExcel = () => {
    const worksheetData: any[] = []

    const headers = ['Sınıf', 'Ders', 'Ürün Adı','Barkod', 'Fiyat', 'Adet', 'Not']
    worksheetData.push(headers)

    data?.eklenenSinifDersleri.eklenensinif.forEach((sinifDetay: any) => {
      const transformedData = sinifDetay.dersler
        .map((dersDetay: any) => [
          sinifDetay.isim || '',
          dersDetay.ders_adi || null,
          dersDetay.urun_adi || null,
          dersDetay.barcode || null,
          dersDetay.etiket_fiyati ? `${getFormattedPrice(dersDetay.etiket_fiyati.toString())}` : null,
          dersDetay.adet || null,
          dersDetay.sinif_not || null,
        ])
        .filter((row: any) => row.slice(2).some((value: string) => value !== null))

      worksheetData.push(...transformedData)
    })

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

    const colWidths = worksheetData[0].map((_: string, colIndex: number) =>
      Math.max(...worksheetData.map((row) => (row[colIndex] ? row[colIndex].toString().length : 10))),
    )
    worksheet['!cols'] = colWidths.map((width: number) => ({ wch: width }))

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'TümVeriler')
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    saveAs(new Blob([excelBuffer]), `${user}.xlsx`)
  }

  const calculateTotals = (dersler: any[]) => {
    let totalAmount = 0
    let totalVAT = 0

    dersler.forEach((ders) => {
      const unitPrice = parseFloat(ders.etiket_fiyati || '0')
      const quantity = ders.adet || 0
      const vatRate = parseFloat(ders.kdv_orani || '0') / 100

      const itemTotal = unitPrice * quantity
      const itemVAT = itemTotal * vatRate

      totalAmount += itemTotal
      totalVAT += itemVAT
    })

    return {
      totalAmount,
      totalVAT,
      totalIncludingVAT: totalAmount + totalVAT,
    }
  }
  return (
    <div className="db-okulyonetim-added-to-class">
      <div className="okulyonetim-added-to-class">
        <div className="okulyonetim-added-to-class-intro">
          <div className="added-class-div">
            <span className="added-class-text">Sınıfa Eklenenler</span>
            <span className="added-class-sub-text">{data?.eklenenSinifDersleri.eklenensinif.length}</span>
          </div>
          <div className="okulyonetim-added-to-class-intro-text">
            <span className="hello-user-text">Merhaba {user} Öğretmenim;</span>
            <span className="hello-sub-text">Aşağıdan sınıflarla ilgili düzenlemelerinizi yapabilirsiniz.</span>
          </div>
          <div className="okulyonetim-added-to-class-intro-button">
            <Button type="primary" onClick={exportAllToExcel}>
              Tüm Verileri Excel'e Aktar <ExcelIcon />
            </Button>
          </div>
        </div>
        {data?.eklenenSinifDersleri.eklenensinif.map((sinifDetay: any) => {
          // Her sınıfın derslerini tabloya uygun formata dönüştür
          const filteredDersler = sinifDetay.dersler.filter((dersDetay: any) => dersDetay.urun_id && dersDetay.urun_adi)
          // excele geçirmek için öncesinde verileri işlemek gerekiyor.
            const excelToSingle = filteredDersler.map((dersDetay: any) => ({
            key: dersDetay.urun_adi + dersDetay.sinif_ders_id,
            productImage: dersDetay?.resim || dersDetay?.resim_url!,
            lesson: dersDetay.ders_adi,
            class: sinifDetay.isim,
            productId: dersDetay.urun_id,
            classId: dersDetay.sinif_ders_id,
            barcode: dersDetay.barcode,
            productName: dersDetay.urun_adi,
            price: dersDetay.etiket_fiyati ? dersDetay.etiket_fiyati.toString().replace('.', ',') : '0',
            quantity: dersDetay.adet,
            ders_aktif: dersDetay.ders_aktif,
            note: dersDetay.sinif_not || '',
            sinif_akif_mi: sinifDetay.sinif_gonderim,
            }))
          // const isExpanded = expandedKeys.includes(sinifDetay.id)
          const exportToExcel = () => {
            const headers = [['Sınıf adı', 'Ders', 'Ürün Adı','Barkod', 'Fiyat', 'Adet', 'Not']]

            const worksheetData = [
              ...headers,
              ...excelToSingle.map((item: any) => [
                item.class,
                item.lesson,
                item.productName,
                item.barcode,
                item.price,
                item.quantity,
                item.note,
              ]),
            ]

            // Excel dosyası oluşturuluyor
            const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, worksheet, 'TabloVerileri')

            // Excel dosyasını dışa aktar
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
            const fileName = sinifDetay.isim.replace(/\s+/g, '_') // Boşlukları "_" ile değiştir
            saveAs(new Blob([excelBuffer]), `${fileName}.xlsx`)
          }
          const { totalAmount, totalVAT } = calculateTotals(filteredDersler)
          return (
            <div className="okulyonetim-added-to-class-content">
              <Collapse bordered={false}>
                <Panel
                  key={sinifDetay.id}
                  header={
                    <div className="okulyonetim-added-to-class-content-title">
                      <div className="title-div">
                        <span className="collapse-title">{sinifDetay.isim}</span>
                        <span className="collapse-filtered-title">{filteredDersler.length}</span>
                      </div>
                      <div className="okulyonetim-added-to-class-intro-button btn-excel">
                        <Tooltip
                          placement="top"
                          title={excelButtonText}
                          mouseEnterDelay={0.2}
                          overlayStyle={tooltipStyle}
                        >
                          <Button type="primary" onClick={exportToExcel}>
                            Excel'e Aktar <ExcelIcon />
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  }
                >
                  {filteredDersler.length > 0 ? (
                    <>
                      <div className="okulyonetim-added-to-class-content-table">
                        <Table
                          columns={columns}
                          dataSource={filteredDersler.map((dersDetay: any) => ({
                            key: dersDetay.urun_adi + dersDetay.sinif_ders_id + dersDetay.etiket_fiyati,
                            productImage: dersDetay?.resim || dersDetay?.resim_url!,
                            class: sinifDetay.isim,
                            lesson: dersDetay.ders_adi,
                            productId: dersDetay.urun_id,
                            classId: dersDetay.sinif_ders_id,
                            productName: dersDetay.urun_adi,
                            kdv: dersDetay.kdv_orani,
                            price: `${dersDetay.etiket_fiyati}`,
                            quantity: dersDetay.adet,
                            note: dersDetay.sinif_not || '',
                            sinif_akif_mi: sinifDetay.sinif_gonderim,
                            ders_aktif: dersDetay.ders_aktif,
                            lessonColor: dersDetay.ders_rengi || '#000',
                          }))}
                          pagination={false}
                          scroll={{ x: true }}
                        />
                      </div>
                      <div className="okulyonetim-added-to-class-content-totals">
                        <div className="okulyonetim-added-to-class-content-totals-price">
                          <div className="total-amount-content">
                            <span className="title"> KDV Dahil Sepet Tutarı</span>
                            <span className="amount"> {totalAmount.toFixed(2)} TL</span>
                          </div>
                          <div className="total-amount-content">
                            <span className="title">KDV Tutarı</span>
                            <span className="amount"> {totalVAT.toFixed(2)} TL</span>
                          </div>
                        </div>
                        <div className="okulyonetim-added-to-class-content-totals-button">
                          {!sinifDetay.sinif_gonderim && (
                            <Tooltip
                              placement="top"
                              title={confirmButtonText}
                              mouseEnterDelay={0.2}
                              overlayStyle={tooltipStyle}
                            >
                              <Button onClick={() => showApprovalModal(sinifDetay.id)}>
                                <SendIcon /> Onay İçin Yöneticiye Gönder
                              </Button>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="okulyonetim-added-to-class-no-products">
                      <p style={{ alignItems: 'center' }}>Sınıf listenize henüz bir ürün eklemediniz.</p>
                    </div>
                  )}
                </Panel>
              </Collapse>
            </div>
          )
        })}
      </div>
      <Modal
        title="Kaldırma İşlemi"
        open={isModalVisible}
        onOk={handleDeleteConfirm}
        onCancel={() => setIsModalVisible(false)}
        okText="Kaldır"
        cancelText="Vazgeç"
      >
        <p>Bu ürünü sinif derslerinden kaldırmak istediğinizden emin misiniz?</p>
      </Modal>
      <Modal
        title="Onaylama Uyarısı"
        open={isApprovalModalVisible}
        onOk={handleSendApproval}
        onCancel={() => setIsApprovalModalVisible(false)}
        okText="Onaya devam etmek istiyorum"
        cancelText="Liste yapmaya devam edeceğim"
      >
        <p>
          Onay verme işleminizi tüm listenizi tamamladıysanız yapmalısınız, onay verdikten sonra listede değişiklik
          yapamayacaksınız.
        </p>
      </Modal>
    </div>
  )
}

export default OkulyonetimAddedToClass
